import { breakpoints, isArray } from "@chakra-ui/utils";

function normalizeBreakpointObject(bps) {
  var result = [];
  result = Object.values(bps);

  for (var key in bps) {
    result[key] = bps[key];
  }

  return result;
}

function normalizeBreakpointArray(bps) {
  var result = bps;

  for (var index = 0; index < bps.length; index++) {
    result[breakpoints[index + 1]] = bps[index];
  }

  return result;
}

export function normalizeBreakpoints(value) {
  return isArray(value) ? normalizeBreakpointArray(value) : normalizeBreakpointObject(value);
}
//# sourceMappingURL=breakpoint.js.map